(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-use"] && !Shopify.designMode) return;
  try {
    
    (function () {
      function initHowTo(root) {
        if (!root || root.dataset.bbInit === '1') return;
        root.dataset.bbInit = '1';

        const tabsScroll = root.querySelector('[data-bb-tabs-scroll]');
        const btnPrev = root.querySelector('[data-bb-tabs-prev]');
        const btnNext = root.querySelector('[data-bb-tabs-next]');
        const tabs = Array.from(root.querySelectorAll('[data-bb-tab]'));

        const stage = root.querySelector('[data-bb-stage]');
        const leftSlot = root.querySelector('[data-bb-left]');
        const rightSlot = root.querySelector('[data-bb-right]');
        const productSlot = root.querySelector('[data-bb-product]');

        const templatesHost = root.querySelector('template[data-bb-templates]');
        const leftTemplates = templatesHost ? Array.from(templatesHost.content.querySelectorAll('template[data-bb-left-template]')) : [];
        const videoTemplates = templatesHost ? Array.from(templatesHost.content.querySelectorAll('template[data-bb-video-template]')) : [];
        const productTemplates = templatesHost ? Array.from(templatesHost.content.querySelectorAll('template[data-bb-product-template]')) : [];

        function tplFind(arr, index) {
          return arr.find(t => String(t.dataset.index) === String(index));
        }
        function cloneInto(slot, tpl) {
          if (!slot) return;
          slot.innerHTML = '';
          if (!tpl) return;
          slot.appendChild(tpl.content.cloneNode(true));
        }

        // Product fallback strategy:
        // - If active tab has product => use it, update lastValid
        // - If not => fallback to lastValid; else fallback to first tab that has product; else fallback to active (empty)
        const firstValidProductIndex = (function () {
          const t = productTemplates.find(x => x.dataset.hasProduct === '1');
          return t ? Number(t.dataset.index) : null;
        })();
        let lastValidProductIndex = firstValidProductIndex;

        function updateArrowState() {
          if (!tabsScroll) return;
          const maxScrollLeft = tabsScroll.scrollWidth - tabsScroll.clientWidth;
          const left = tabsScroll.scrollLeft;
          if (btnPrev) btnPrev.disabled = left <= 2;
          if (btnNext) btnNext.disabled = left >= (maxScrollLeft - 2);
        }
        function scrollTabs(direction) {
          if (!tabsScroll) return;
          const amount = Math.max(220, Math.round(tabsScroll.clientWidth * 0.7));
          tabsScroll.scrollBy({ left: direction * amount, behavior: 'smooth' });
        }

        if (btnPrev) btnPrev.addEventListener('click', () => scrollTabs(-1));
        if (btnNext) btnNext.addEventListener('click', () => scrollTabs(1));
        if (tabsScroll) {
          tabsScroll.addEventListener('scroll', updateArrowState, { passive: true });
          window.addEventListener('resize', updateArrowState);
          updateArrowState();
        }

        function closeOtherDetails(container, keep) {
          const all = Array.from(container.querySelectorAll('details'));
          all.forEach(d => { if (d !== keep) d.open = false; });
        }

        function setActive(index) {
          const i = Number(index);

          tabs.forEach((t, idx) => {
            const active = idx === i;
            t.setAttribute('aria-selected', active ? 'true' : 'false');
            t.tabIndex = active ? 0 : -1;
          });

          // Swap LEFT + RIGHT
          cloneInto(leftSlot, tplFind(leftTemplates, i));
          cloneInto(rightSlot, tplFind(videoTemplates, i));

          // Auto-attach accordion behavior (single open + animated)
          const acc = leftSlot ? leftSlot.querySelector('[data-bb-accordion]') : null;
          if (acc) {
            const details = Array.from(acc.querySelectorAll('details'));
            details.forEach(d => {
              const summary = d.querySelector('summary');
              if (!summary) return;
              d._bbAnimating = false;

              summary.addEventListener('click', (e) => {
                e.preventDefault();
                if (d._bbAnimating) return;

                if (d.open) {
                  // Animate close
                  d._bbAnimating = true;
                  const wrap = d.querySelector('.brownbee-howto__content-wrap');
                  if (wrap) {
                    wrap.style.gridTemplateRows = '0fr';
                    wrap.addEventListener('transitionend', function handler() {
                      wrap.removeEventListener('transitionend', handler);
                      d.open = false;
                      wrap.style.gridTemplateRows = '';
                      d._bbAnimating = false;
                    }, { once: true });
                  } else {
                    d.open = false;
                    d._bbAnimating = false;
                  }
                } else {
                  // Close others first (instant), then open this one
                  details.forEach(other => {
                    if (other !== d && other.open) {
                      other.open = false;
                      const otherWrap = other.querySelector('.brownbee-howto__content-wrap');
                      if (otherWrap) otherWrap.style.gridTemplateRows = '';
                    }
                  });
                  d.open = true;
                }
              });
            });
          }

          // Product selection with fallback
          let productIndexToUse = i;
          const prodTpl = tplFind(productTemplates, i);
          const hasProduct = prodTpl && prodTpl.dataset.hasProduct === '1';

          if (hasProduct) {
            lastValidProductIndex = i;
            productIndexToUse = i;
          } else if (lastValidProductIndex !== null && tplFind(productTemplates, lastValidProductIndex)) {
            productIndexToUse = lastValidProductIndex;
          } else if (firstValidProductIndex !== null) {
            productIndexToUse = firstValidProductIndex;
            lastValidProductIndex = firstValidProductIndex;
          } else {
            productIndexToUse = i; // will be empty template
          }

          cloneInto(productSlot, tplFind(productTemplates, productIndexToUse));

          // Keep active tab in view
          // const activeTab = tabs[i];
          // if (activeTab && activeTab.scrollIntoView) {
            // try { activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); } catch (e) {}
          // }

          // Try autoplay for injected HTML5 video (if present)
          const injectedVideo = rightSlot ? rightSlot.querySelector('video') : null;
          if (injectedVideo) {
            const attempt = injectedVideo.play();
            if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
          }

          // Update tabpanel label
          if (stage) stage.setAttribute('aria-labelledby', 'brownbee-howto-tab-{{ sid }}-' + i);
        }

        // Keyboard navigation
        tabs.forEach((tab) => {
          tab.addEventListener('click', () => setActive(tab.dataset.index));
          tab.addEventListener('keydown', (e) => {
            const key = e.key;
            const current = Number(tab.dataset.index);

            if (key === 'Enter' || key === ' ') {
              e.preventDefault();
              setActive(current);
              return;
            }
            if (key === 'ArrowRight' || key === 'ArrowLeft') {
              e.preventDefault();
              const dir = key === 'ArrowRight' ? 1 : -1;
              const next = (current + dir + tabs.length) % tabs.length;
              tabs[next].focus({ preventScroll: true });
              setActive(next);
            }
          });
        });

        // AJAX add to cart (event delegation; works after swapping)
        async function addToCart(variantId, quantity = 1) {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity) })
          });
          if (!res.ok) {
            let msg = 'Error';
            try {
              const j = await res.json();
              msg = (j && (j.description || j.message)) ? (j.description || j.message) : msg;
            } catch (_) {}
            throw new Error(msg);
          }
          return res.json();
        }

        root.addEventListener('click', async (e) => {
          const btn = e.target.closest('[data-bb-add]');
          if (!btn || !root.contains(btn)) return;
          e.preventDefault();
          if (btn.disabled) return;

          const variantId = btn.getAttribute('data-variant-id');
          if (!variantId) return;

          const addingText = btn.getAttribute('data-adding-text') || 'Adding…';
          const addedText = btn.getAttribute('data-added-text') || 'Added';
          const errorText = btn.getAttribute('data-error-text') || 'Error';

          const originalHTML = btn.innerHTML;
          btn.disabled = true;
          btn.innerHTML = '<span class="brownbee-howto__addlabel">' + addingText + '</span>';

          try {
            await addToCart(variantId, 1);
            btn.innerHTML = '<span class="brownbee-howto__addlabel">' + addedText + '</span>';

            try {
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
            } catch (_) {}

            setTimeout(() => {
              btn.innerHTML = originalHTML;
              btn.disabled = false;
            }, 1400);
          } catch (err) {
            btn.innerHTML = '<span class="brownbee-howto__addlabel">' + errorText + '</span>';
            setTimeout(() => {
              btn.innerHTML = originalHTML;
              btn.disabled = false;
            }, 1600);
            console.warn('[Brownbee HowTo] addToCart error:', err);
          }
        });

        // Init default
        setActive(0);
      }

      function initAll() {
        document.querySelectorAll('[data-bb-howto]').forEach(initHowTo);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
      } else {
        initAll();
      }

      document.addEventListener('shopify:section:load', function () {
        initAll();
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-dynamic-content"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('[data-custom-component="tabs-image"]').forEach(sectionContainer => {
        const shopifySection = sectionContainer.closest('.shopify-section');
        const sectionId = shopifySection ? shopifySection.id.replace('shopify-section-', '') : 'default';

        const container = document.querySelector(`.td-dynamic-content-${ sectionId }`);
        const triggers = container.querySelectorAll('.td-trigger');
        const images = container.querySelectorAll('.td-image-block');
        const content = container.querySelectorAll('.td-content-above-links');

        triggers.forEach(trigger => {
            trigger.addEventListener('click', function(e) {
            e.preventDefault();
            const index = this.getAttribute('data-index');

            triggers.forEach(t => t.classList.remove('is-active'));
            images.forEach(img => img.classList.remove('is-active'));
            content.forEach(cont => cont.classList.remove('is-active'));

            this.classList.add('is-active');
            const targetTrigger = container.querySelector(`.td-trigger[data-index="${index}"]`);
            if (targetTrigger) {
                targetTrigger.classList.add('is-active');
            }

            const targetImage = container.querySelector(`.td-image-block[data-index="${index}"]`);
            if (targetImage) {
                targetImage.classList.add('is-active');
            }

            const targetContent = container.querySelector(`.td-content-above-links[data-index="${index}"]`);
            if (targetContent) {
                targetContent.classList.add('is-active');
            }
            });
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-ucg"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const videos = document.querySelectorAll('.hover-video');
    const isMobile = window.matchMedia("(max-width: 750px)");

    videos.forEach(video => {
      if (!video.src && video.querySelector('source')) {
        video.src = video.querySelector('source').src;
      }
      
      video.muted = true;
      video.setAttribute('playsinline', '');
      video.preload = "auto";

      video.addEventListener('playing', () => {
        video.dataset.ready = "true";
      });

      video.addEventListener('pause', () => {
        video.dataset.ready = "false";
      });
    });

    const handlePlay = (video) => {
      video.play().catch(() => {});
    };

    const handlePause = (video) => {
      video.pause();
    };

    // --- MOBILE LOGIC ---
    const mobileObserver = new IntersectionObserver((entries) => {
      if (!isMobile.matches) return;
      entries.forEach(entry => {
        if (entry.isIntersecting) handlePlay(entry.target);
        else handlePause(entry.target);
      });
    }, { threshold: 0.6 });

    // --- DESKTOP LOGIC ---
    videos.forEach(video => {
      mobileObserver.observe(video);
      video.addEventListener('mouseenter', () => !isMobile.matches && handlePlay(video));
      video.addEventListener('mouseleave', () => !isMobile.matches && handlePause(video));
    });
  });

  } catch(e) { console.error(e); }
})();
})();
